import { AdminLayout } from '../../components/admin/layout/AdminLayout';
import CMSManagement from '../../components/admin/CMSManagement';

export function CMSPage() {
  return (
    <AdminLayout
      title="Contenu (CMS)"
      description="Gérez le contenu éditorial du site"
    >
      <CMSManagement />
    </AdminLayout>
  );
}
